
export const baseProductSGropus = [
    'base_product_read',
];